import React, { PropsWithChildren } from 'react';
import { useParams } from 'react-router-dom';

type CustomDetailProps = {
  propertyIds: string[];
};

export const CustomDetail: React.FC<PropsWithChildren<CustomDetailProps>> = ({ children, propertyIds }) => {
  const { id = '' } = useParams();
  if (!propertyIds.includes(id)) return null;
  return <>{children}</>;
};
